<template>
    <b-modal
        id="checkoutModal"
        v-model="companyModal"
        size="lg"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <p>Pentru a primi o ofertă de preț din partea <strong>Smis</strong>, vă rugăm să trimiteți un email pe adresa
                <a href="mailto:office@smis.ro" class="font-weight-bold">office@smis.ro</a> cu numărul companiilor pe care doriți să le adăugați.</p>
            <p class="mt-3">Vom reveni în cel mai scurt timp cu o ofertă personalizată pentru dumneavoastră!</p>
        </div>
    </b-modal>
</template>

<script>
import {BModal,} from 'bootstrap-vue';

export default {
    components: {
        BModal,
    },
    props: {
        companyModal: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        onHide(evt) {
            if (evt.trigger === "backdrop") {
                evt.preventDefault();
                this.$emit('hideTempModal')
            }
        },
    }
}
</script>

<style scoped>
.modal-body p, .modal-body a {
    color: #fff;
    text-align: center;
    font-size: 14px;
}
</style>